export default function MobileMenu() {
	const mobileMenuToggles = document.querySelectorAll('.js-menu-toggle');

	if (!mobileMenuToggles) {
		return;
	}

	mobileMenuToggles.forEach((toggle) => {
		toggle.addEventListener('click', () => {
			const body = document.querySelector('body');
			//toggle.classList.toggle('menu-toggle--active');
			body.classList.toggle('menu-open');
		});
	});
}
